import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-sales-received-quantity-card',
  templateUrl: './sales-received-quantity-card.component.html',
  styleUrls: ['./sales-received-quantity-card.component.scss'],
})
export class SalesReceivedQuantityCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public countSales: number = 0;
  public countSalesPercent: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getSalesCount()
      .then((value) => {
        this.countSales = value.currentValue;
        this.countSalesPercent = value.percentLastPeriod;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
